import { Gym, GymTypes } from 'fitbeat.models';
import React, { FunctionComponent } from 'react';
import { StyleSheet, View } from 'react-native';
import Theme from '../../theme';
import { HomeOutlineIcon, LocationIcon } from '../../ui/components/Icons';
import { defaultScale } from '../../utils/scaling';
import { ButtonMargin, SelectionContainer } from './SelectionContainer';

interface IProps {
  currentGym: Gym | null;
  homeGym: Gym;
  defaultStudioGym: Gym;
  studioGymLocation: string;
  isOfficeScheduleBooking: boolean;
  onPress(gymName: string, atStudio: boolean): void;
}

export function GymLocationSelection({
  currentGym,
  homeGym,
  defaultStudioGym,
  studioGymLocation,
  onPress,
  isOfficeScheduleBooking,
}: IProps) {
  const isHomeSelected = !!(currentGym && currentGym.type === GymTypes.Home)
    && !isOfficeScheduleBooking;
  const isStudioSelected = !!(currentGym && currentGym.type === GymTypes.Indoor)
    || (currentGym && isOfficeScheduleBooking);

  return (
    <View style={styles.container}>
      <SelectionContainer
        title='Studio'
        subTitle={`(${studioGymLocation})`}
        isSelected={isStudioSelected}
        style={{ marginRight: defaultScale(ButtonMargin) }}
        onPress={() => onPress(defaultStudioGym.name, true)}
        icon={(
          <LocationIcon
            size={defaultScale(38)}
            color={isStudioSelected ? Theme.WHITE : Theme.CHARCOAL}
          />
        )}
      />

      <SelectionContainer
        title='Home'
        isSelected={isHomeSelected}
        style={{ marginLeft: defaultScale(ButtonMargin) }}
        onPress={() => onPress(homeGym.name, false)}
        icon={(
          <HomeOutlineIcon
            size={defaultScale(38)}
            color={isHomeSelected ? Theme.WHITE : Theme.CHARCOAL}
          />
        )}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
  },
});
